module.exports = __webpack_public_path__ + "media/images/icons/outlined/delete-d400b0b1a15824ead401b62fc2af7e9f.svg";